module.exports = __webpack_public_path__ + "static/media/LearnCreatorStepPublish.9c8cdca6.jpg";